<template>
  <div class="comments">
    <comment
      v-for="comment of comments"
      :key="`comment${comment.id}`"
      :object-type="objectType"
      :object-id="objectId"
      :comment="comment"
    />

    <comment-form
      v-if="userData"
      :object-type="objectType"
      :object-id="objectId"
    />
  </div>
</template>

<script>
import Comment from '@/components/Comment.vue';
import CommentForm from '@/components/CommentForm.vue';

export default {
  components: {
    Comment,
    CommentForm,
  },
  props: {
    objectType: {
      type: String,
      required: true,
    },
    objectId: {
      type: Number,
      required: true,
    },
    comments: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .comments {
    margin-top: 0.5rem;
    border-top: 1px solid var(--gray-lighter);
  }
</style>
